module.exports = {
	"id": "JP",
	"name": "Japan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.014272,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.021408,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.014272,
			"22": 0.014272,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.007136,
			"28": null,
			"29": 0.07136,
			"30": 0.014272,
			"31": 0.014272,
			"32": null,
			"33": 0.007136,
			"34": 0.007136,
			"35": 0.021408,
			"36": 0.007136,
			"37": 0.007136,
			"38": 0.014272,
			"39": 0.042816,
			"40": 0.014272,
			"41": 0.028544,
			"42": 0.085632,
			"43": 0.1784,
			"44": 0.028544,
			"45": 0.24976,
			"46": 0.042816,
			"47": 0.064224,
			"48": 0.192672,
			"49": 2.005216,
			"50": 0.335392,
			"51": 1.448608,
			"52": 0.442432,
			"53": 17.183488,
			"54": 4.367232,
			"55": 0.07136,
			"56": 0.028544,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.028544,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.014272,
			"11": 0.007136,
			"12": 0.014272,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.03568,
			"17": null,
			"18": null,
			"19": 0.014272,
			"20": null,
			"21": 0.007136,
			"22": null,
			"23": 0.007136,
			"24": 0.007136,
			"25": 0.007136,
			"26": null,
			"27": null,
			"28": 0.014272,
			"29": 0.007136,
			"30": null,
			"31": 0.014272,
			"32": null,
			"33": 0.014272,
			"34": 0.028544,
			"35": 0.057088,
			"36": 0.028544,
			"37": 0.028544,
			"38": 0.10704,
			"39": 0.03568,
			"40": 0.028544,
			"41": 0.028544,
			"42": 0.042816,
			"43": 0.221216,
			"44": 0.085632,
			"45": 0.264032,
			"46": 0.221216,
			"47": 0.892,
			"48": 0.92768,
			"49": 8.969952,
			"50": 0.057088,
			"51": 0.021408,
			"52": null,
			"3.5": null,
			"3.6": 0.028544
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.03568,
			"37": 0.042816,
			"38": 0.228352,
			"39": 0.014272,
			"40": 0.292576,
			"41": 0.049952,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.007136,
			"12.1": 0.221216
		},
		"safari": {
			"0": null,
			"4": 0.085632,
			"5": 0.149856,
			"6": 0.085632,
			"7": 0.128448,
			"8": 0.313984,
			"9": 0.264032,
			"10": 1.776864,
			"3.1": null,
			"3.2": null,
			"5.1": 0.39248,
			"6.1": 0.278304,
			"7.1": 0.049952,
			"9.1": 1.455744
		},
		"ios_saf": {
			"8": 0,
			"10": 13.3770397211,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.36049574157,
			"8.1-8.4": 0.666000607306,
			"9.0-9.2": 0.317725060366,
			"9.3": 4.84734386969
		},
		"android": {
			"3": 0,
			"4": 0.0289998966408,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0036249870801,
			"4.1": 0.104606770026,
			"4.2-4.3": 0.261516925065,
			"4.4": 0.599676434109,
			"4.4.3-4.4.4": 0.60485498708
		},
		"ie": {
			"6": 0.0587863255419,
			"7": 0.0514380348491,
			"8": 0.992019243519,
			"9": 0.77891881343,
			"10": 0.536425220569,
			"11": 14.8729403621,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00691040186566,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000191955607379
		},
		"edge": {
			"12": 0.07136,
			"13": 0.827776,
			"14": 2.633184
		},
		"ie_mob": {
			"10": 0.0101616338028,
			"11": 0.0413723661972
		},
		"bb": {
			"7": 0.00214725,
			"10": null
		},
		"samsung": {
			"0": 0.750106
		},
		"and_uc": {
			"0": 0.406546
		},
		"op_mini": {
			"0": 0.093102642527
		},
		"and_chr": {
			"0": 8.652697
		},
		"and_ff": {
			"0": 0.034356
		}
	},
	"total": 97.17747625
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/JP.json
 ** module id = 559
 ** module chunks = 0
 **/